import React from "react";
import { Check } from "lucide-react";
import { about } from "../mock";

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          {/* photo */}
          <div className="lg:col-span-5 reveal">
            <div className="relative">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-b from-[var(--gold)]/15 to-transparent" />
              <div className="relative rounded-3xl border border-[var(--line)] bg-[var(--ink-2)] overflow-hidden flex items-end justify-center pt-8">
                <img
                  src={about.photo}
                  alt={about.name}
                  className="w-full max-w-sm object-contain"
                />
              </div>
              <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 whitespace-nowrap bg-[var(--black)] border border-[var(--gold)]/40 rounded-full px-6 py-2.5">
                <span className="text-sm text-white font-semibold">26 Years <span className="text-[var(--gold-soft)]">·</span> Export Strategist</span>
              </div>
            </div>
          </div>

          {/* text */}
          <div className="lg:col-span-7 reveal">
            <p className="eyebrow">{about.eyebrow}</p>
            <h2 className="mt-5 font-serif-display text-4xl sm:text-5xl font-semibold">
              {about.name}
            </h2>
            <p className="mt-2 text-[var(--gold)]">{about.role}</p>

            <div className="mt-7 space-y-5">
              {about.story.map((para, i) => (
                <p key={i} className="text-[var(--ivory)]/80 leading-relaxed">
                  {para}
                </p>
              ))}
            </div>

            <div className="mt-9 grid sm:grid-cols-2 gap-4">
              {about.credentials.map((c, i) => (
                <div key={i} className="flex items-start gap-3">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-[var(--gold)]/15 flex items-center justify-center shrink-0">
                    <Check size={14} className="text-[var(--gold)]" />
                  </span>
                  <span className="text-sm text-[var(--ivory)]/80">{c}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
